import { string, func, number, instanceOf } from 'prop-types'
import cn from 'classnames'

import isDark from '../../../utilities/isDark.js'
import keyPress from '../../../utilities/keyPress.js'
import sendTrackingEvent from '../../../utilities/sendTrackingEvent.js'
import Settings from '../../../../models/settings.js'

export default function LoadMoreButton({
  backgroundColor = '',
  columns,
  currentPostsCount,
  feedKey,
  load,
  loadMore = () => null,
  settings,
}) {
  const {
    allowCookies,
    enableWebAnalytics,
    showLoadMoreButton,
    theme,
    isInfiniteScrollEnabled,
    postCount,
    postsToShow,
    hasDisplayLimit,
  } = settings

  const styles = {
    backgroundColor: settings.loadMoreButtonBackgroundColor,
    borderRadius: settings.loadMoreButtonRounding,
    color: settings.loadMoreButtonTextColor,
  }

  if (settings.isAutoTheme) {
    return null
  }

  if (
    !showLoadMoreButton ||
    isInfiniteScrollEnabled ||
    currentPostsCount >= postCount ||
    (hasDisplayLimit && currentPostsCount >= postsToShow)
  ) {
    return null
  }

  const backgroundIsDark = isDark(backgroundColor)
  const buttonClassName = theme === 'tile-grid' ? 'tilegrid' : 'cardflow'
  const args =
    theme === 'card-flow' || theme === 'card-flow-centered' ? { limit: columns * 2 } : undefined
  const bottomBarClassname =
    theme === 'tile-grid' || theme === 'tile-grid-auto'
      ? 'bzfy-c-tilegrid-bottom-bar'
      : 'bzfy-c-cardflow-bottom-bar'

  const handleClick = () => {
    sendTrackingEvent({
      action: 'click',
      allowCookies,
      enableWebAnalytics,
      eventName: 'embed_load_more_clicked',
      eventLabel: 'load_more',
      eventAction: 'clicked',
      interactive: true,
      flowKey: feedKey,
      target: 'flow',
    })
    loadMore()
    load(args)
  }
  return (
    <div className={bottomBarClassname}>
      <div
        className={cn('bzfy-feed-load-more-button', {
          [`bzfy-c-${buttonClassName}-button--dark`]: !backgroundIsDark,
        })}
        onClick={handleClick}
        onKeyDown={(e) => {
          keyPress(e, handleClick)
        }}
        role="button"
        style={{ ...styles }}
        tabIndex={0}
      >
        {settings.locale.getTranslation('loadmore')}
      </div>
    </div>
  )
}

LoadMoreButton.propTypes = {
  backgroundColor: string,
  columns: number,
  currentPostsCount: number.isRequired,
  feedKey: string.isRequired,
  load: func.isRequired,
  loadMore: func,
  settings: instanceOf(Settings).isRequired,
}
